export default class Appointment {

	constructor (data) {
		if (data) {
			this.id = parseInt(data.id)
			this.name = data.name
			this.datetime = data.date
			this.location = data.location
			this.description = data.description
		} else {
			this.name = ''
			this.datetime = ''
			this.location = ''
			this.description = ''
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/Appointment.js